import { PipeTransform, Pipe } from '@angular/core';
import { enumToList } from '../enum-to-list';
import { ProgramType } from '../../enums';
import { IdName } from 'src/app/shared/models/id-name.model';

@Pipe({
  name: 'programType',
  standalone: false
})
export class ProgramTypePipe implements PipeTransform {
  public transform(value: ProgramType): string {
    return getProgramType(value);
  }
}

export function getProgramType(value: ProgramType): string {
  switch (value) {
    case ProgramType.FieldTraining:
      return 'Onboarding';
    case ProgramType.PerformanceEvaluation:
      return 'Performance';
    case ProgramType.ProbationaryPeriod:
      return 'Probationary';
    case ProgramType.Mentoring:
      return 'Mentoring';
    default:
      throw new Error(`Unsupported value for ProgramType: ${value}.`);
  }
}

export function getProgramTypeStringUrl(value: ProgramType): string {
  switch (value) {
    case ProgramType.FieldTraining:
      return 'field-training';
    case ProgramType.PerformanceEvaluation:
      return 'performance-evaluation';
    case ProgramType.ProbationaryPeriod:
      return 'probationary-period';
    case ProgramType.Mentoring:
      return 'mentoring';
    default:
      throw new Error(`Unsupported value for ProgramType: ${value}.`);
  }
}

const PROGRAM_TYPE_ORDERING = Object.freeze([
  ProgramType.FieldTraining,
  ProgramType.ProbationaryPeriod,
  ProgramType.PerformanceEvaluation
]);

export function getProgramTypeList(): IdName[] {
  const list = enumToList(ProgramType, getProgramType);

  return PROGRAM_TYPE_ORDERING.map((x) => list.find((y) => y.id === x));
}
